<template>
	<div class="contact">
		<div class="banner"></div>
		<div class="main">
			<transition name="BottomIn">
				<div class="title" v-show="title">
					<p>联系我们</p>
					<div class="line"></div>
					<img src="../assets/images/contact_title_text.png" width="185" height="37" style="margin-left: -93px;" />
				</div>
			</transition>


			<div class="map_box">
				<baidu-map class="map" :center="center" :zoom="zoom" :scroll-wheel-zoom="true">
					<!-- <bm-navigation anchor="BMAP_ANCHOR_BOTTOM_RIGHT"></bm-navigation> -->
					<bm-marker :position="{lng:121.446123, lat:31.300819}" :dragging="true" animation="BMAP_ANIMATION_BOUNCE">
					</bm-marker>
				</baidu-map>
			</div>


			<transition name="BottomIn">
				<div class="info" v-show="info">
					<img class="text" src="../assets/images/contact_text_bg.png" width="507" height="201" />
					<img class="point" src="../assets/images/contact_point.png" width="200" height="200" />
					<img class="point_1" src="../assets/images/contact_point_1.png" width="188" height="176" />
					<ul>
						<li>
							<div class="icon">
								<img class="b" src="../assets/images/contact_icon_1.png" width="44" height="44" />
								<img class="w" src="../assets/images/contact_icon_1_w.png" width="44" height="44" />
							</div>
							<div class="sub">
								<p>Address<br />地址</p>
							</div>
							<div class="btm">
								<p>上海市静安区万荣路1268号云<br />立方A座6层</p>
							</div>
						</li>
						<li style="margin: 0 70px;">
							<div class="icon">
								<img class="b" src="../assets/images/contact_icon_2.png" width="44" height="44" />
								<img class="w" src="../assets/images/contact_icon_2_w.png" width="44" height="44" />
							</div>
							<div class="sub">
								<p>Contact number<br />联系电话</p>
							</div>
							<div class="btm">
								<p class="tel">400-016-8989</p>
							</div>
						</li>
						<li>
							<div class="icon">
								<img class="b" src="../assets/images/contact_icon_3.png" width="44" height="44" />
								<img class="w" src="../assets/images/contact_icon_3_w.png" width="44" height="44" />
							</div>
							<div class="sub">
								<p>Email<br />邮箱</p>
							</div>
							<div class="btm">
								<p>bd@qiangyuntech.com<br />hr@qiangyuntech.com</p>
							</div>
						</li>
					</ul>
				</div>
			</transition>


		</div>
	</div>
</template>

<script>
	import Vue from 'vue'
	import BaiduMap from 'vue-baidu-map'

	Vue.use(BaiduMap, {
		/* Visit http://lbsyun.baidu.com/apiconsole/key for details about app key. */
		ak: 'piXQ5CgHFqEefqCVbhhBFfe6HjF7l4zW'
	})
	export default {
		data() {
			return {
				center: {
					lng: 121.446123,
					lat: 31.300819
				},
				zoom: 16,
				info: false,
				title: false,
				map: false
			}
		},
		created() {

		},
		mounted() {
			this.title = true
			setTimeout(() => {
				this.map = true
			}, 500);
			setTimeout(() => {
				this.info = true
			}, 800);
		},
		computed: {

		},
		watch: {},
		methods: {},
		components: {}
	}
</script>
<style scoped>
	/* 去掉地图左下角的百度LOGO */
	.map_box>>>.anchorBL {
		display: none
	}
</style>
<style scoped lang="less">
	@keyframes scale {
		0% {
			transform: scale(1);
		}

		50% {
			transform: scale(1.2);
		}

		100% {
			transform: scale(1);
		}
	}

	@keyframes move {
		0% {
			transform: translateY(0px);
		}

		50% {
			transform: translateY(10px);
		}

		100% {
			transform: translateY(0px);
		}
	}

	.info {
		padding-top: 30px;
		position: relative;

		.text {
			position: absolute;
			z-index: 1;
			left: -260px;
			top: 10px;
		}

		.point {
			position: absolute;
			z-index: 5;
			right: -100px;
			bottom: -100px;
			-webkit-animation: scale 3s infinite;
			-moz-animation: scale 3s infinite;
			-ms-animation: scale 3s infinite;
			animation: scale 3s infinite;
		}

		.point_1 {
			position: absolute;
			z-index: 1;
			left: -285px;
			top: -100px;
			-webkit-animation: move 2s infinite;
			-moz-animation: move 2s infinite;
			-ms-animation: move 2s infinite;
			animation: move 2s infinite;
		}

		ul {
			position: relative;
			z-index: 4;
			display: flex;
			align-items: center;
			justify-content: center;

			li {
				width: 244px;
				height: 244px;
				box-sizing: border-box;
				padding: 20px 0 0 20px;
				background: #FFFFFF;
				box-shadow: -1px 10px 14px 0px #F0F2F4;
				border-radius: 12px 74px 12px 12px;

				.icon {
					margin-bottom: 50px;

					.b {
						display: block;
					}

					.w {
						display: none;
					}
				}

				.sub {
					color: #333;
					font-size: 13px;
					margin-bottom: 30px;
					line-height: 1.2;
					padding-left: 5px;
				}

				.btm {
					padding-left: 5px;

					p {
						font-size: 14px;
						font-weight: 500;
						line-height: 1.1;
						font-weight: 500;
						color: #333;

						&.tel {
							font-size: 20px;
						}
					}
				}

				&:hover {
					background: linear-gradient(180deg, #B9FF49 0%, #8BE200 100%);
					box-shadow: 0px 18px 18px 0px rgba(118, 196, 125, 0.31);

					.icon {
						.b {
							display: none;
						}

						.w {
							display: block;
						}
					}

					.sub {
						color: #fff;
					}

					.btm {
						p {
							color: #fff;
						}
					}
				}
			}
		}
	}

	.map_box {
		width: 870px;
		height: 270px;
		background: #fff;
		box-shadow: rgba(0, 0, 0, 0.1) 0 0 13px;

		.map {
			width: 100%;
			height: 100%;
		}
	}

	.title {
		position: relative;
		margin-bottom: 30px;

		img {
			position: absolute;
			z-index: 1;
			left: 50%;
			top: -14px;
		}

		p {
			position: relative;
			z-index: 2;
			font-size: 24px;
			font-weight: 500;
			color: #162E6B;
			text-align: center;
			line-height: 1;
			margin-bottom: 12px;
		}

		.line {
			position: relative;
			margin: 0 auto;
			z-index: 2;
			height: 1px;
			width: 367px;
			background: #fff;

			&::before {
				content: '';
				position: absolute;
				left: 50%;
				margin-left: -13px;
				top: -4px;
				width: 26px;
				height: 8px;
				background: #FFFFFF;
				border-radius: 4px;
			}
		}
	}

	.contact {
		padding-top: 56px;
	}

	.banner {
		height: 448px;
		background: url(../assets/images/contact_page_bg.png) no-repeat;
		background-size: cover;
	}

	.main {
		width: 870px;
		margin: -390px auto 0 auto;




	}
</style>
